import { c as _c } from "react/compiler-runtime";
import { EmployeesRow, Spacing, Text } from '@newfront-insurance/core-ui';
import type { JSX } from 'react';
import type { Employee } from '../../../../../bff/types';
interface Props {
  servicingTeam: Employee[];
  containerId?: string;
}
export function ServicingTeam(t0) {
  const $ = _c(6);
  const {
    servicingTeam,
    containerId
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Spacing height={24} />;
    t2 = <Text size="small">Servicing team</Text>;
    t3 = <Spacing height={8} />;
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== containerId || $[4] !== servicingTeam) {
    t4 = <>{t1}{t2}{t3}<EmployeesRow employees={servicingTeam} containerId={containerId} /></>;
    $[3] = containerId;
    $[4] = servicingTeam;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}